export default __webpack_public_path__ + "assets/space_rocks.d83de238.png";